import DatePeriodPicker from '@/components/common/dateperiodpicker/DatePeriodPicker.vue'
import ClientPicker from '@/components/client/picker/ClientPicker.vue'
import UserPicker from '@/components/user/picker/UserPicker.vue'

export default {
  name: 'TableFilter',
  props: ['value', 'filter', 'disabled'],
  data () {
    return {
      isMounted: false,
      content: null
    };
  },
  components: {
    DatePeriodPicker,
    ClientPicker,
    UserPicker
  },
  methods: {
    updateFilter (val) {
      this.content = this.BasicHelper.cloneObject(val);
      this.updateValue();
    },
    updateValue () {
      this.$emit('input', this.content);
      this.$emit('changed', this.content);
    },
    updateItems (options) {
      if (this.$refs.searchcheclist) {
        this.$refs.searchcheclist.updateItems(options);
      }
    }
  },
  watch: {
    value: {
      immediate: true,
      handler (val) {
        this.content = val;
        if (val === null && this.filter.type === 'date-period' && this.$refs.datePerPicker) {
          this.$refs.datePerPicker.clearSearch();
        }
      }
    }
  },
  mounted () {
    this.content = this.value;
    this.isMounted = true;
  }
}
